"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_CONSENT_REQUIRED_COUNTRY_CODES = exports.CloudFlareConnectingIp = exports.CloudFlareCityKey = exports.CloudFlareCountryKey = exports.CloudFlareRegionKey = void 0;
const country_1 = require("../internationalization/enums/country");
exports.CloudFlareRegionKey = "cf-region";
exports.CloudFlareCountryKey = "cf-ipcountry";
exports.CloudFlareCityKey = "cf-ipcity";
exports.CloudFlareConnectingIp = "cf-connecting-ip";
exports.COOKIE_CONSENT_REQUIRED_COUNTRY_CODES = [country_1.CountryCode.DE, country_1.CountryCode.IE];
